// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/baiCertificate.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certificate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
  min-height: 900px;
  width: 100%;
}

.certificate,
.certificate h1,
.certificate h2,
.certificate h3 {
  width: 100%;
}

.certificate h1,
.certificate h2,
.certificate h3 {
  color: #000;
  position: absolute;
  text-align: center;
}

.certificate h1 {
  top: 19%;
  font-size: 42px;
  font-weight: bold;
}

.certificate h2 {
  top: 43%;
  font-size: 32px;
}

.certificate h3 {
  bottom: 29%;
  font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/certificate.css"],"names":[],"mappings":"AAAA;EACE,yDAA+D;EAC/D,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".certificate {\n  background-image: url('../../assets/images/baiCertificate.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  height: 100%;\n  min-height: 900px;\n  width: 100%;\n}\n\n.certificate,\n.certificate h1,\n.certificate h2,\n.certificate h3 {\n  width: 100%;\n}\n\n.certificate h1,\n.certificate h2,\n.certificate h3 {\n  color: #000;\n  position: absolute;\n  text-align: center;\n}\n\n.certificate h1 {\n  top: 19%;\n  font-size: 42px;\n  font-weight: bold;\n}\n\n.certificate h2 {\n  top: 43%;\n  font-size: 32px;\n}\n\n.certificate h3 {\n  bottom: 29%;\n  font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
